module.exports = __webpack_public_path__ + "static/media/lips.fd964f6a.svg";